import { normalizeCasePhasesList } from './caseWorkflowProgress';

/**
 * Évalue les actions lot (Commander la suite) à partir des phases timeline.
 * @param {Array<{ group?: string|number, phase_order?: number, status?: string }>} phases
 */
export function evaluateCaseLotContinuation(phases) {
  const list = normalizeCasePhasesList(phases);
  if (!list.length) {
    return {
      canCommanderSuite: false,
      hasFollowUpLotInProgress: false,
      activeGroupNum: 1,
    };
  }

  const groupMap = {};
  for (const p of list) {
    const g = String(p.group ?? '');
    if (!g) continue;
    if (!groupMap[g]) groupMap[g] = [];
    groupMap[g].push(p);
  }

  const activatedGroups = Object.entries(groupMap)
    .filter(([, groupPhases]) => groupPhases.some((p) => p.status !== 'pending'))
    .map(([g, groupPhases]) => ({
      groupNum: parseInt(g, 10),
      phases: [...groupPhases].sort((a, b) => (b.phase_order ?? 0) - (a.phase_order ?? 0)),
    }))
    .filter(({ groupNum }) => !Number.isNaN(groupNum))
    .sort((a, b) => b.groupNum - a.groupNum);

  if (!activatedGroups.length) {
    return {
      canCommanderSuite: false,
      hasFollowUpLotInProgress: false,
      activeGroupNum: 1,
    };
  }

  const lastActive = activatedGroups[0];
  const lastPhase = lastActive.phases[0];
  const allCompleted = lastActive.phases.every((p) => p.status === 'completed');

  let canCommanderSuite = false;
  if (lastActive.groupNum === 1) {
    canCommanderSuite = lastPhase?.status === 'completed';
  } else {
    canCommanderSuite = allCompleted;
  }

  const hasFollowUpLotInProgress =
    lastActive.groupNum > 1 &&
    lastActive.phases.some((p) => p.status === 'in_progress' || p.status === 'submitted');

  return {
    canCommanderSuite,
    hasFollowUpLotInProgress,
    activeGroupNum: lastActive.groupNum,
  };
}

/**
 * Éligibilité « Nouvelle conception 3D » : fin de phase Expédition du lot en cours
 * (même règle que Commander la suite).
 * @param {{ caseStatus?: string, phases?: Array }} params
 */
export function canStartNewConceptionVersion({ caseStatus, phases = [] }) {
  if (['archived', 'cancelled', 'draft'].includes(caseStatus)) return false;
  return evaluateCaseLotContinuation(phases).canCommanderSuite;
}
